import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor — wird vom Bootstrap importiert, OHNE den Barrel
 * (BotBubble, ChatPanel, Streaming-API) eager zu ziehen.
 *
 * Wir nutzen bewusst KEINEN Slot — `BotBubble` wird direkt in AppShell
 * gemountet (analog zu `<CommandPalette />`), weil der Bot global UND
 * positions-flexibel (4 Ecken) ist. Ein Slot würde nur Komplexität
 * hinzufügen, ohne Mehrwert.
 */
const manifest: SkillManifest = {
  key: 'ai-smart-assistant',
  name: 'KI-Companion-Bot',
  description:
    'Floatender Chat-Bot rechts unten — kontextbewusst (kennt das aktuelle Projekt), antwortet im Streaming-Modus.',
  category: 'ai',
  version: '0.1.0',
  requiredPermissions: [Permission.AI_USE],
  enabledByDefault: true,
};

export const aiSmartAssistantSkill: FrontendSkill = {
  manifest,
};
